
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-saya",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-saya/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-saya"])
      });
    }
  